import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Confirmation from "./component";
import {
  downloadAssessmentResult,
  updateConfimation,
  viewAssessmentReport,
} from "./actions";
import {
  getAssessment,
  getAssessmentAttemptByUserId,
  getInsightfulContent,
  sendToFriendReportOnEmail,
} from "../dashboard/actions";
import { createContentMap, getContentLatestVersion } from "../signup/actions";
import { getAssessmentResultByAssessmentAttemptId } from "../plan/actions";
import {
  createGuestUser,
  getBilling,
  getGuestUser,
  getTransactionDetail,
  GetUserById,
  isGuestOrPremiumUser,
} from "../settings/actions";

const mapStateToProps = ({ funnelStep }) => ({ funnelStep });

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      viewAssessmentReportConnect: viewAssessmentReport,
      getAssessmentAttemptByUserIdConnect: getAssessmentAttemptByUserId,
      getInsightfulContentConnect: getInsightfulContent,
      getContentLatestVersionConnect: getContentLatestVersion,
      createContentMapConnect: createContentMap,
      getAssessmentResultByAssessmentAttemptIdConnect:
        getAssessmentResultByAssessmentAttemptId,
      getUserByIdConnect: GetUserById,
      sendToFriendReportOnEmailConnect: sendToFriendReportOnEmail,

      getAssessmentConnect: getAssessment,

      getGuestUserConnect: getGuestUser,
      getTransactionDetailConnect: getTransactionDetail,
      guestUserChangesConnect: createGuestUser,
      getBillingConnect: getBilling,
      isGuestOrPremiumUserConnect: isGuestOrPremiumUser,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Confirmation);
